(() => {
  if (customElements.get('testimonials-element')) {
    return;
  }

  class TestimonialsElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.initSlider();
    }

    initElements() {
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        mousewheel: {
          forceToAxis: true,
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 8,
        breakpoints: {
          1200: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
          990: {
            slidesPerView: 2,
          },
        },
      };
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('testimonials-element', TestimonialsElement);
})();
